<template>
    <div :class="css.container" v-on="ons.container()" v-bind="binds.container" :style="clearable && '--input-spacing-x-r: 70px'">
        <ui-icon v-if="icon" name="search" :class="css.icon" v-on="ons.icon()" />
        <ui-icon
            v-if="keyword && clearable"
            name="close"
            :class="css.close"
            @click="
                emit('update:modelValue', '');
                emit('search');
            " />
        <ui-input :class="css.input" v-model="keyword" v-bind="binds.main" v-on="ons.main()" ref="input" />

        <!-- * 候选项 -->
        <transition v-on="animations.selector(true)">
            <div class="ui-form-candidates" v-show="visible" :class="[css.candidates, classExtraName]" v-bind="binds.candidates">
                <div class="ui-form-candidate-container">
                    <render-options />
                </div>
            </div>
        </transition>
    </div>
</template>

<script lang="tsx" setup>
//* 组件库
import type { UiTypes } from "various-ui";
import { animations } from "various-ui";
import { UiInput, UiIcon } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
import { DefaultSearchPropsOption, DefaultSearchEmits } from "./index";
//* 样式
import css from "./style/index.module.less";

//* 组件属性注册
const define = defineProps(DefaultSearchPropsOption);
const emit = defineEmits(DefaultSearchEmits);

//* 组合函数
const { ons, refs, nodes, binds, watchs, methods, computeds } = useComposable(define, emit);
const { data, keyword } = refs;
const { input } = nodes;
const { candidates, visible } = computeds;

//* 渲染函数
const renderOptions = defineComponent({
    render() {
        const renderOption = (res: UiTypes.candidate) => {
            const species = useSpeciesIconKey(res.type);
            const className: string[] = [css.candidate, "ui-form-candidate"];
            if (data.value && data.value.value == res.value && data.value.id == res.id) {
                className.push("ui-active");
            }

            if (res.alias) {
                className.push(css.alias);
                return (
                    <div class={className} onMousedown={() => methods.select(res)}>
                        <div class={[css.name, "ellipsis"]}>
                            <span>[{useSpeciesName(res.type)}]</span>
                            <span v-html={res.label} title={res.label}></span>
                        </div>
                        <div class={"ellipsis"} v-html={res.alias} title={res.alias}></div>
                    </div>
                );
            } else if (species) {
                className.push(css[species]);
                return (
                    <div class={className} onMousedown={() => methods.select(res)}>
                        <UiIcon name={species} />
                        <span v-html={res.label} title={res.label}></span>
                        <span>[{useSpeciesName(res.type)}]</span>
                    </div>
                );
            } else {
                return (
                    <div class={className} onMousedown={() => methods.select(res)}>
                        <span v-html={res.label} title={res.label}></span>
                    </div>
                );
            }
        };

        return <div class={"ui-form-candidate-content"}>{candidates.value?.map((value) => renderOption(value))}</div>;
    },
});

//* 组件属性导出
defineExpose({ reset: methods.reset });
//* 组件卸载前注册监听器
onBeforeUnmount(() => {
    watchs.stop?.();
});
</script>
